import { translate } from '~/translations/Trans';
import maptiveIqLogo from '../../../../../assets/images/maptiveiQLogo.svg';
import maptiveLogo from '../../../../../assets/images/maptiveSVGfromEPS.svg';

export enum LogoVersion {
  default = 'default',
  variantB = 'variantB'
}

export const getLogoSource = (version?: LogoVersion) => {
  switch (version) {
    case LogoVersion.variantB:
      return maptiveIqLogo;

    case LogoVersion.default:
    default:
      return maptiveLogo;
  }
};

export const getLogoTagLine = (version?: LogoVersion) => {
  switch (version) {
    case LogoVersion.variantB:
      return translate('login.tagline.maptiveIQ');

    default:
      return null;
  }
};
